export const isScene = (name) => {
  return window.location.href.includes(name);
};
